import * as React from 'react';
import Animated, { FadeIn } from 'react-native-reanimated';
import { FullScreenSpinner, isWeb, View } from 'smoothie';

import { useUserAuthorization } from '../../auth/hooks/useUserAuthorization';
import TabHeader from '../../common/components/TabHeader';
import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import LogRocketFacade from '../../logger/log-rocket/LogRocketFacade';
import { captureException } from '../../logger/Logger';
import useGetAllBankAccountDetailsLegacy from '../hooks/useGetAllBankAccountDetailsLegacy';
import useGetCurrentInterestRateAndApy from '../hooks/useGetCurrentInterestRateAndApy';
import LegacyEmptySpaces from './spaces/LegacyEmptySpaces';
import LegacySpacesOverview from './spaces/LegacySpacesOverview';

const LegacyBankingOverview = ({
    includeHeader = true,
}: {
    includeHeader?: boolean;
}) => {
    LogRocketFacade.tagPage('LegacyBankingOverview');

    const user = useAuthedUser();
    const { limitedAccessScope } = useUserAuthorization();

    const {
        isLoading: isLoadingBankAccountDetails,
        errorFetching,
        hasAccount,
        totalAvailableBalance,
        totalInterestEarned,
        bankAccountDetails,
    } = useGetAllBankAccountDetailsLegacy();

    const { data: currentInterestRate, isLoading: isLoadingInterestRate } =
        useGetCurrentInterestRateAndApy({});

    if (
        !hasAccount &&
        (isLoadingBankAccountDetails ||
            isLoadingInterestRate ||
            limitedAccessScope === null)
    ) {
        return <FullScreenSpinner />;
    }

    if (errorFetching) {
        // TODO: Render error state
        captureException(new Error('Error fetching banking details for user'));
    }

    return (
        <View flex={1} testID="banking-tab">
            {includeHeader && (
                <TabHeader headerTitle={hasAccount ? 'Banking' : ''} />
            )}

            <Animated.View
                entering={FadeIn.duration(500)}
                style={{ flex: 1, ...(isWeb && { overflowY: 'auto' }) }}
            >
                {hasAccount ? (
                    <LegacySpacesOverview
                        totalAvailableBalance={totalAvailableBalance}
                        totalInterestEarned={totalInterestEarned}
                        bankAccountDetails={bankAccountDetails}
                    />
                ) : (
                    <LegacyEmptySpaces
                        currentInterestRate={currentInterestRate}
                        user={user}
                    />
                )}
            </Animated.View>
        </View>
    );
};

export default LegacyBankingOverview;
